// Category headers over the dock sections the catalog kept.
import type { ReactNode } from "react";
import type { DockSectionDefinition, DockSectionRenderContext } from "@/components/activity/sectionTypes";
import type { AttentionSectionGroups } from "@/lib/attention/attentionCatalog";
import { AttentionMessageInbox } from "./AttentionMessageInbox";
import { NegativeOnHandAttentionRow } from "./NegativeOnHandAttentionRow";

function Group(props: { title: string; children: ReactNode }) {
  return (
    <section className="mt-3" aria-label={props.title}>
      <h3 className="px-0.5 text-[10px] font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
        {props.title}
      </h3>
      {props.children}
    </section>
  );
}

function renderIds(
  ids: readonly string[],
  sections: readonly DockSectionDefinition[],
  ctx: DockSectionRenderContext,
) {
  return ids.map((id) => {
    const section = sections.find((row) => row.id === id);
    if (!section) return null;
    return <div key={id}>{section.render(ctx)}</div>;
  });
}

export function ActivityAttentionGroups(props: {
  sections: readonly DockSectionDefinition[];
  groups: AttentionSectionGroups;
  renderCtx: DockSectionRenderContext;
  showNegativeOnHand: boolean;
  negativeOnHandCount: number;
}) {
  const { groups, sections, renderCtx } = props;
  const needs =
    groups.needsYou.length > 0 || props.showNegativeOnHand ? (
      <Group title="Needs you">
        {props.showNegativeOnHand ? (
          <NegativeOnHandAttentionRow
            count={props.negativeOnHandCount}
            onOpenInventory={renderCtx.onOpenMfgInventory}
          />
        ) : null}
        {renderIds(groups.needsYou, sections, renderCtx)}
      </Group>
    ) : null;

  return (
    <>
      {needs}
      <AttentionMessageInbox onClosePanel={renderCtx.onCloseDock} />
      {groups.updates.length > 0 ? (
        <Group title="Updates">{renderIds(groups.updates, sections, renderCtx)}</Group>
      ) : null}
      {groups.history.length > 0 ? (
        <Group title="History">{renderIds(groups.history, sections, renderCtx)}</Group>
      ) : null}
    </>
  );
}
